__webpack_require__.p = "/lotto/";